import { useEffect, useState } from "react";
import { useLocation } from "wouter";

export function RouteEffects() {
  const [location] = useLocation();
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const heading = document.querySelector("h1")?.textContent?.trim();
    if (heading) setAnnouncement(`${heading} page loaded`);
  }, [location]);

  return <div className="sr-only" role="status" aria-live="polite">{announcement}</div>;
}
